// Constants
import { USER_API } from '../constants/configs';
import { API_REQUEST } from '../constants/general';
import { Actions } from '../redux/actions';

// Utility Functions
import API from '../utils/api';
import { dispatch } from '../utils/store';
import { handleError, handleSuccess } from '../utils/toast';
import { handleProfileScore } from './profileScore';

export const getResumeDetailsData = (search, pageNumber, size, toastReff) => {
  dispatch(Actions.User.SetLoading, true);
  const params = {
    ...(!!search ? { search } : {}),
    ...(!!pageNumber ? { page: pageNumber, limit: size } : {})
  };

  API(API_REQUEST.get, `${USER_API}/list-resumes`, { params })
    .then((res) => {
      handleSuccess(toastReff, res);
      dispatch(Actions.User.SetLoading, false);
      dispatch(Actions.Resumes.SetResumes, res?.data?.data?.data?.resumes || []);
      dispatch(Actions.Resumes.SetTotalRecords, res?.data?.data?.data?.count || 0);
    })
    .catch((error) => {
      dispatch(Actions.User.SetLoading, false);
      handleError(toastReff, error);
      console.log(error);
    });
};

export const deleteResume = (id, search, pageNumber, size, toastReff, setDeleteResumeModal) => {
  dispatch(Actions.User.SetLoading, true);
  API(API_REQUEST.delete, `${USER_API}/remove-resume?id=${id}`)
    .then((res) => {
      handleSuccess(toastReff, res);
      dispatch(Actions.User.SetLoading, false);
      setDeleteResumeModal(false);
      getResumeDetailsData(search, pageNumber, size, toastReff);
      handleProfileScore(toastReff);
    })
    .catch((error) => {
      dispatch(Actions.User.SetLoading, false);
      handleError(toastReff, error);
      console.log(error);
    });
};

export const getDataFromResume = async (data, toastReff) => {
  try {
    dispatch(Actions.User.SetLoading, true);
    const res = await API(API_REQUEST.post, `${USER_API}/extract-details-from-resume`, data, true);
    handleSuccess(toastReff, res);
    return res?.data?.data?.data || null;
  } catch (error) {
    // Retry condition
    if (
      error?.response?.data?.success === 'true' &&
      (error?.response?.data?.data?.message === 'Error' ||
        error?.response?.data?.data?.statusCode === 500)
    ) {
      try {
        const retryRes = await API(
          API_REQUEST.post,
          `${USER_API}/extract-details-from-resume`,
          data,
          true
        );
        // success toast only after retry success
        handleSuccess(toastReff, retryRes);
        return retryRes?.data?.data?.data || null;
      } catch (retryError) {
        console.log(retryError, 'retryError');
        handleError(toastReff, retryError);
        return null;
      }
    }
    // If it's not a retry condition → then show error toast
    handleError(toastReff, error);
    return null;
  } finally {
    dispatch(Actions.User.SetLoading, false);
  }
};

export const updateResumeDetails = (data, onHide, toastReff, getData, selectedResume) => {
  dispatch(Actions.User.SetLoading, true);
  API(
    selectedResume?.ID ? API_REQUEST.put : API_REQUEST.post,
    selectedResume?.ID
      ? `${USER_API}/update-resume?id=${selectedResume?.ID}`
      : `${USER_API}/add-resume`,
    data,
    true
  )
    .then((res) => {
      handleSuccess(toastReff, res);
      getData();
      onHide();
      if (!selectedResume?.ID) handleProfileScore(toastReff);
    })
    .catch((error) => {
      handleError(toastReff, error);
      dispatch(Actions.User.SetLoading, false);
      console.log(error);
    });
};
